import { React, useState } from 'react';
import { FxmsData } from '../datas/FxData';
import { AttrListEdit } from "./../datas/OpClass";

export function FxIconButtonConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrText(10, "title", '아이콘타이틀', 500);
  setList.makeAttrText(20, "iconName", '아이콘이미지',500);
  setList.makeAttrButton(30, "cmdAdd", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;  
}


export const FxIconButton = (props) => {
  const {id, fxUiGrp, fxUiGrpItem} = props;
  const [iconImage, setIconImage] = useState(fxUiGrpItem && fxUiGrpItem.attrObj && fxUiGrpItem.attrObj.iconName ? fxUiGrpItem.attrObj.iconName : 'flarestack.ico');

  const openModal = () => {
    /* const uiGrpNo = opObj.getAttrValue("uiGrpNo", -1); */
    console.log("iconButton Test");
  }


  return (
    <>
        <img className='FxIconButton' src={iconImage}/>
    </>  
  ) 
};

export default {FxIconButton};